import React            from 'react';
import ReactBubbleChart from 'react-bubble-chart';
import styled from 'styled-components';

//import Actions          from '../Actions';

const StyledBubbleChart = styled(ReactBubbleChart)`
  min-width: 280px;
  min-height: 160px;

  @media only screen and (min-width: 1200px) {
    min-width: 300px;
    min-height: 180px;
  }
`;

class BubbleChart extends React.Component {
  render () {
    var data = this.props.data && this.props.data.map(d => ({
      _id: d._id,
      value: d.value,
      colorValue: d.sentiment,
      selected: d.selected
    }));
    const bgColors = ["#0e67ba", "#d9a8e4", "#d06768", "#4da084", "#95759f"]

    return <StyledBubbleChart
      className="my-cool-chart"
      data={data}
      font-size={"12px"}
      selectedColor={bgColors[this.props.colorIndex || 0]}
      selectedTextColor="#fff"
      fixedDomain={{min: -1, max: 1}}
      fontSizeFactor={0.5}
      smallDiameter={90}
      mediumDiameter={150}
    />;
  }
}

export default BubbleChart;



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/BubbleChart.js